export const generateFilteredPDF = async (filteredData) => {
  if (!filteredData || filteredData.length === 0) {
    alert("No data to export!");
    return;
  }

  const { jsPDF } = await import("jspdf");
  const formatDate = (d) => {
    if (!d) return "N/A";
    try {
      return new Date(d).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return String(d);
    }
  };

  const formatIncome = (v) => {
    if (!v) return "N/A";
    const n = Number(v);
    return isNaN(n) ? String(v) : "Rs. " + n.toLocaleString("en-IN");
  };

  const toBase64 = (url) =>
    new Promise((resolve) => {
      if (!url) return resolve(null);
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          canvas.width = img.naturalWidth;
          canvas.height = img.naturalHeight;
          canvas.getContext("2d").drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/jpeg", 0.8));
        } catch {
          resolve(null);
        }
      };
      img.onerror = () => resolve(null);
      setTimeout(() => resolve(null), 5000);
      img.src = url;
    });

  const pdf = new jsPDF({ orientation: "p", unit: "mm", format: "a4" });

  const PW = 210;
  const PH = 297;
  const M = 10;
  const CW = PW - M * 2; 

  const GREEN = [20, 83, 45];
  const GOLD = [184, 134, 11];
  const WHITE = [255, 255, 255];
  const LGRAY = [248, 249, 250];
  const MGRAY = [209, 213, 219];
  const DGRAY = [107, 114, 128];
  const BLACK = [31, 41, 55];
  const ACTIVE_C = [22, 163, 74];
  const REG_C = [202, 138, 4];
  const SIGNUP_C = [156, 163, 175];

  let pageNum = 1;
  let yPos = 0;

  const drawHeader = () => {
    pdf.setFillColor(...GREEN);
    pdf.rect(0, 0, PW, 17, "F");

    pdf.setFillColor(...GOLD);
    pdf.rect(0, 17, PW, 1.5, "F");

    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(12);
    pdf.setTextColor(...WHITE);
    pdf.text("VAISNAVA MARRIAGE", M, 11);

    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(8);
    pdf.text("Filtered Users Report", PW - M, 8, { align: "right" });
    pdf.text(
      `Total: ${filteredData.length}  |  Page ${pageNum}  |  ${new Date().toLocaleDateString("en-IN")}`,
      PW - M,
      14,
      { align: "right" },
    );

    yPos = 22;
  };

  const drawFooter = (total) => {
    pdf.setFillColor(243, 244, 246);
    pdf.rect(0, PH - 9, PW, 9, "F");
    pdf.setFont("helvetica", "normal");
    pdf.setFontSize(7);
    pdf.setTextColor(150, 150, 150);
    pdf.text(
      `Vaisnava Marriage Bureau  |  Page ${pageNum} of ${total}  |  ${new Date().toLocaleString("en-IN")}`,
      PW / 2,
      PH - 3.5,
      { align: "center" },
    );
  };

  const drawCard = async (user, idx) => {
    const CARD_H = 76;
    const IMG_SZ = 20;

 
    if (yPos + CARD_H > PH - 12) {
      drawFooter("?");
      pdf.addPage();
      pageNum++;
      drawHeader();
    }

    const x = M;
    const y = yPos;
    const imgX = x + 5;
    const imgY = y + 5;
    const cx = imgX + IMG_SZ + 6;
    const cw = CW - (IMG_SZ + 14);

    pdf.setFillColor(...LGRAY);
    pdf.setDrawColor(...MGRAY);
    pdf.setLineWidth(0.3);
    pdf.roundedRect(x, y, CW, CARD_H, 3, 3, "FD");

    
    pdf.setFillColor(...GOLD);
    pdf.rect(x, y, 3.5, CARD_H, "F");

    const imgUrl =
      user.profilePic ||
      user.photo ||
      user.image ||
      user.profileImage ||
      user.imageUrl ||
      user.avatar ||
      "";

    if (imgUrl) {
      const b64 = await toBase64(imgUrl);
      if (b64) {
        try {
          pdf.addImage(b64, "JPEG", imgX, imgY, IMG_SZ, IMG_SZ);
          pdf.setDrawColor(...MGRAY);
          pdf.setLineWidth(0.3);
          pdf.roundedRect(imgX, imgY, IMG_SZ, IMG_SZ, 2, 2, "S");
        } catch {
       
        }
      }
    }

    const serialCX = imgX + IMG_SZ / 2;
    const serialCY = imgY + IMG_SZ + 5;
    pdf.setFillColor(...GOLD);
    pdf.circle(serialCX, serialCY, 4.2, "F");
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(7);
    pdf.setTextColor(...WHITE);
    pdf.text(String(idx + 1), serialCX, serialCY + 1.5, { align: "center" });

    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(13);
    pdf.setTextColor(...GREEN);
    pdf.text(String(user.name || "N/A").substring(0, 28), cx, y + 12);

    const isActive = user.isActive === true && user.profileCompleted === true;
    const isReg =
      !isActive &&
      (user.profileCompletionPercentage > 0 || user.isActive === false);
    const statusLabel = isActive ? "Active" : isReg ? "Registered" : "Signup";
    const statusColor = isActive ? ACTIVE_C : isReg ? REG_C : SIGNUP_C;
    const badgeW = statusLabel === "Registered" ? 24 : 17;

    pdf.setFillColor(...statusColor);
    pdf.roundedRect(x + CW - badgeW - 3, y + 5, badgeW, 7.5, 2, 2, "F");
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(7);
    pdf.setTextColor(...WHITE);
    pdf.text(statusLabel, x + CW - badgeW / 2 - 3, y + 10, { align: "center" });

    if (user.isVerified || user.verified) {
      pdf.setFillColor(...ACTIVE_C);
      pdf.roundedRect(x + CW - badgeW - 30, y + 5, 25, 7.5, 2, 2, "F");
      pdf.setFontSize(7);
      pdf.setTextColor(...WHITE);
      pdf.text("Verified", x + CW - badgeW - 17.5, y + 10, { align: "center" });
    }

    pdf.setDrawColor(...MGRAY);
    pdf.setLineWidth(0.25);
    pdf.line(cx, y + 15.5, x + CW - 3, y + 15.5);

    const fields = [
      ["Date of Birth", formatDate(user.dateOfBirth || user.dob)],
      ["Height", user.height ? `${user.height} cm` : "N/A"],
      ["Current City", user.currentCity || user.city || "N/A"],

      ["Birth Time", user.birthTime || "N/A"],
      ["Mother Tongue", user.motherTongue || "N/A"],
      ["Annual Income", formatIncome(user.annualIncome)],

      ["Birth City", user.birthCity || "N/A"],
      ["Education", user.education || user.qualification || "N/A"],
      ["Spiritual Status", user.spiritualStatus || "N/A"],

      ["Occupation", user.occupation || user.occupations || "N/A"],
      ["Marital Status", user.maritalStatus || "N/A"],
      ["Caste", user.caste || "N/A"],
    ];

    const colW = cw / 3;
    const rowH = 10;
    const startY = y + 20;

    fields.forEach(([label, value], i) => {
      const row = Math.floor(i / 3);
      const col = i % 3;
      const fx = cx + col * colW;
      const fy = startY + row * rowH;

    
      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(7);
      pdf.setTextColor(...DGRAY);
      pdf.text(label, fx, fy);

    
      pdf.setFont("helvetica", "bold");
      pdf.setFontSize(8.5);
      pdf.setTextColor(...BLACK);
      pdf.text(String(value || "N/A").substring(0, 25), fx, fy + 5);
    });

    const stripY = y + CARD_H - 11;
    pdf.setDrawColor(229, 231, 235);
    pdf.setLineWidth(0.3);
    pdf.line(x + 4, stripY, x + CW - 4, stripY);

    const dateFields = [
      ["Signup", formatDate(user.registrationDate || user.registerDate)],
      ["Registration", formatDate(user.registrationDate || user.registerDate)],
      ["Profile Completed", formatDate(user.profileCompletedDate)],
    ];

    dateFields.forEach(([label, val], i) => {
      const dx = cx + (i * cw) / 3;
      pdf.setFont("helvetica", "normal");
      pdf.setFontSize(7);
      pdf.setTextColor(...DGRAY);
      pdf.text(`${label}: `, dx, stripY + 7);
      const lw = pdf.getTextWidth(`${label}: `);
      pdf.setFont("helvetica", "bold");
      pdf.setTextColor(...BLACK);
      pdf.text(val, dx + lw, stripY + 7);
    });

    yPos += CARD_H + 4;
  };

  drawHeader();

  for (let i = 0; i < filteredData.length; i++) {
    await drawCard(filteredData[i], i);
  }

  const total = pdf.internal.getNumberOfPages();
  for (let p = 1; p <= total; p++) {
    pdf.setPage(p);
    drawFooter(total);
  }

  const today = new Date().toISOString().split("T")[0];
  pdf.save(`VMB_Filtered_Users_${today}.pdf`);
};
